import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { AppPhase, SupervisorAction, SupervisorSubPhase, WorkerAccessLevel } from '../../../models/communication/app-enums.model';
import { AppState } from '../../../models/communication/app-state.model';
import { SupervisorPanelComponent } from '../supervisor-panel/supervisor-panel.component';

/**
 * Showing a correct {@link SupervisorPanelComponent} or {@link GameSelectionComponent}
 * based on the provided state (`supervisorState.subPhase` and `supervisorState.selectedAction`).
 *
 * The panels are used to inform the supervisor about the different states of the app,
 * mostly to confirm the previously selected action.
 *
 * The `AppPhase.TableClosed` is a special initial phase that needs supervisor to login and select a game.
 * *
 * The provided `supervisorLogoutMode` is a local (frontend only) variable that is set to true
 * when the logout button in the header is clicked.
 */
@Component({
    selector: 'app-supervisor-panels',
    standalone: true,
    imports: [CommonModule, SupervisorPanelComponent],
    templateUrl: './supervisor-panels.component.html'
})
export class SupervisorPanelsComponent {
    @Input()
    state!: AppState;

    @Output()
    readonly cancelActionClicked = new EventEmitter();

    protected readonly AppPhase = AppPhase;
    protected readonly WorkerAccessLevel = WorkerAccessLevel;
    protected readonly SupervisorSubPhase = SupervisorSubPhase;
    protected readonly SupervisorAction = SupervisorAction;
}
